export const PUBLIC_ROUTES_MAP = {
  login: '/login',
  logout: '/logout',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  requestAccess: '/request-access',
  changeTemporaryPassword: '/change-temporary-password',
  contentHubViewerPublic: '/public/:pageSlug',
};
